import { useEffect, useState } from 'react'

import { Typography, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'

import moment from 'moment-timezone'
import _ from 'lodash'

import appleTemplateConfig from './apple_template'
import googleClassConfig from './google_class'
import googleObjectConfig from './google_object'
import instanceDataConfig from './instance_data'

const EventConfig = ({ passTypeId, setPrevButtonState, setNextButtonState, template, setTemplate, classData, setClassData, objectData, setObjectData, instanceData, setInstanceData }) => {

  const now = moment()
  const isSmartixScannerEvent = /smartix_/.test(passTypeId)
  const templateType = isSmartixScannerEvent ? "smartix" : "standard"

  const initialDate = instanceData.__event_date__

  const [eventDate, setEventDate] = useState(moment(initialDate, "YYYYMMDDHHmmSS"))
  const [assignedSeats, setAssignedSeats] = useState("yes")
  const [multipleTicketTypes, setMultipleTicketTypes] = useState("single")
  const [seatingFormat, setSeatingFormat] = useState("gate")

  const fixedGoogleFields = [
    {
      "body": null,
      "header": null,
      "id": "____smartix___messages___",
      "type": "text"
    },
    {
      "body": null,
      "header": null,
      "id": "____issued___by___",
      "type": "text"
    },
    {
      "body": null,
      "header": null,
      "id": "____smartix___advert___",
      "type": "text"
    }
  ]


  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("enabled")
  }, [])

  useEffect(() => {

    let t = _.cloneDeep(template)
    let c = _.cloneDeep(classData)
    let o = _.cloneDeep(objectData)
    let i = _.cloneDeep(instanceData)

    if (assignedSeats === "no") {
      t.auxiliaryFields = []
      c.classTemplateInfo.cardTemplateOverride.cardRowTemplateInfos = [googleClassConfig[templateType].row1[multipleTicketTypes]]
      o.textModulesData = googleObjectConfig[templateType].row1[multipleTicketTypes].concat(fixedGoogleFields)

      delete i.seating
      delete i.__seating__
    } else {
      t.auxiliaryFields = appleTemplateConfig.auxiliaryFields[templateType][seatingFormat]
      t.secondaryFields = appleTemplateConfig.secondaryFields[templateType][multipleTicketTypes]

      c.classTemplateInfo.cardTemplateOverride.cardRowTemplateInfos = []
      c.classTemplateInfo.cardTemplateOverride.cardRowTemplateInfos.push(googleClassConfig[templateType].row1[multipleTicketTypes])
      c.classTemplateInfo.cardTemplateOverride.cardRowTemplateInfos.push(googleClassConfig[templateType].row2[seatingFormat])
      
      o.textModulesData = googleObjectConfig[templateType].row1[multipleTicketTypes].concat(googleObjectConfig[templateType].row2[seatingFormat]).concat(fixedGoogleFields)
      
      if (isSmartixScannerEvent) {
        i.__seating__ = instanceDataConfig[templateType][seatingFormat]
      } else {
        i.seating = instanceDataConfig[templateType][seatingFormat]
      }
    }

    setTemplate(t)
    setClassData(c)
    setObjectData(o)
    setInstanceData(i)

  }, [seatingFormat, assignedSeats,multipleTicketTypes])

  useEffect(() => {
    let i = _.cloneDeep(instanceData)
    
    if (isSmartixScannerEvent) {
      _.set(i,"__event_date__",eventDate.format("YYYYMMDDHHmmSS"))
      _.set(i,"__pass_validity__.__end__",eventDate.add(3,"day").format("YYYYMMDDHHmmSS"))
    }

    setInstanceData(i)
  }, [eventDate])

  return (
    <div className='flex flex-col gap-5 mb-10'>
      <Typography variant="h3" sx={{ p: 2 }}>Configure Event</Typography>

      <FormLabel id="ticket_types">Event Date & Time</FormLabel>
      <div className='flex flex-row justify-between'>
        <DateCalendar value={eventDate} onChange={date => setEventDate(date)} minDate={now} format='DD/MM/YYYY' />
        <TimePicker value={eventDate} onChange={date => setEventDate(date)} ampm={false} />
      </div>

      <div>
        <FormLabel id="ticket_types">Ticket Types</FormLabel>
        <RadioGroup
          row
          aria-labelledby="ticket_types"
          value={multipleTicketTypes}
          onChange={e => setMultipleTicketTypes(e.target.value)}
        >
          <FormControlLabel value="single" control={<Radio />} label="Only a single ticket types will be used" />
          <FormControlLabel value="multiple" control={<Radio />} label="Multiple ticket types required" />
        </RadioGroup>
        <div className='text-gray-300 italic'>You may have different ticket types, eg. standard/VIP or seated / standing.</div>
      </div>

      <div>
        <FormLabel id="assigned_seats">Seating</FormLabel>
        <RadioGroup
          row
          aria-labelledby="assigned_seats"
          value={assignedSeats}
          onChange={e => setAssignedSeats(e.target.value)}
        >
          <FormControlLabel value="yes" control={<Radio />} label="Some or all tickets have assigned seats" />
          <FormControlLabel value="no" control={<Radio />} label="No assigned seats" />
        </RadioGroup>
      </div>

      {["yes", "both"].includes(assignedSeats) &&
        <div>
          <FormLabel id="seating_format">Seat number format</FormLabel>
          <RadioGroup
            aria-labelledby="seating_format"
            value={seatingFormat}
            onChange={e => setSeatingFormat(e.target.value)}
          >
            <FormControlLabel value="gate" control={<Radio />} label="Gate, Section, Row and Seat Number" />
            <FormControlLabel value="section" control={<Radio />} label="Section, Row and Seat Number" />
            <FormControlLabel value="row" control={<Radio />} label="Row and Seat Number" />
            <FormControlLabel value="seat" control={<Radio />} label="Seat Number only" />
          </RadioGroup>
          <div className='text-gray-300 italic'>You can edit the titles later. eg. You might like to change section to floor level</div>
        </div>
      }


    </div>
  )
}

export default EventConfig
